import { Component, ElementRef, HostListener, Inject, OnInit, ViewChild } from '@angular/core';
import { AppState } from 'src/app/root-store/state';
import { Store, select } from '@ngrx/store';
import { Router } from '@angular/router';
import { selectSearchState, selectPageCount, selectDisplayPages, selectMatchedAnnouncementCount, selectIsExpanded, selectAnnouncements, selectPreviewAnnouncements, selectIsSearchResultLoading, selectSearchResultMetaData, selectSearchPageListtBanner, selectSearchPageLeftBanner, selectSearchPageTopBanner, selectFilterExpanded, selectNextSearchPageQueryParams, selectPreviuseSearchPageQueryParams, selectSearchPageBannerIds } from 'src/app/root-store/announcement-store/search-page/selectors';
import { AnnouncementFilter } from 'src/app/shared/models/announcement-filter';
import { AnnouncementService } from 'src/app/shared/services/announcement.service';
import { Observable, Subscription, combineLatest, filter, fromEvent, take } from 'rxjs';
import { selectSalaryOptions, selectPublishDateOptions, ProviderWebsiteUrlMap, selectCurrentWebsite, selectCurrentUserType } from 'src/app/root-store/selectors';
import { SearchState } from 'src/app/root-store/announcement-store/search-page/state';
import { loadFrontPageAnnouncements } from 'src/app/root-store/announcement-store/announcement-front-page-actions';
import { PageNameEnum } from 'src/app/shared/models/enums/page-names-enum';
import { Announcement } from '../shared/models/announcement-model';
import { loadLastListingPage, sendBannerViewToAnalytic } from 'src/app/root-store/actions';
import { MetaService } from 'src/app/shared/services/meta.service';
import { Banner } from 'src/app/banner/shared/models/banner-model';
import { BannerTargetEnum } from 'src/app/banner/shared/models/enums/banner-target-enum';
import { BannerPositionEnum } from 'src/app/banner/shared/models/enums/banner-position-enum';
import { getSearchPageBannerList, toggleExpandFilter } from 'src/app/root-store/announcement-store/search-page/actions';
import { Breakpoints } from 'src/app/shared/models/breakpoints-model';
import { SsrService } from '@hrra/core';
import { DOCUMENT } from '@angular/common';
import { EnvService, PagingNavItem, RoutablePagingNavItem } from '@hrra/core';
import { OptionItem } from '@hrra/common-models';
import { DeviceDetectionService, Range } from '@hrra/core';
import { BannerHeaderPositionId } from 'src/app/shared/models/enums/banner-header-position-id-enum';
import { OverlayService } from 'primeng/api';

@Component({
    selector: 'app-ann-search',
    templateUrl: './ann-search.component.html',
    styleUrls: ['./ann-search.component.scss'],
    standalone: false
})
export class AnnSearchComponent implements OnInit {

  @ViewChild('searchFilter')
  searchFilter!: any;

  metaDataSubscription: Subscription;

  pageId: any;

  providerWebsiteId: number

  date = new Date();

  targetId: number = BannerTargetEnum.Desktop;
  isDesktop = false;

  constructor(@Inject(DOCUMENT) private _document,
              private store: Store<AppState>, 
              private router: Router, 
              private announcementService: AnnouncementService, 
              private metaService: MetaService,
              private deviceDetectionService: DeviceDetectionService,
              private envService: EnvService,
              private ssr: SsrService) {
                this.pageName = PageNameEnum;
                this.pageId = BannerHeaderPositionId.SearchResultPage
              }

  public search$: Observable<SearchState>;
  
  public isFilterExpanded$: Observable<boolean>;

  public salaryOptions$: Observable<OptionItem<Range<number>>[]>;
  public publishDateOptions$: Observable<OptionItem<Range<number>>[]>;

  public pageCount$: Observable<number>;
  public navItems$: Observable<RoutablePagingNavItem[]>;
  public previousePageQueryParams$: Observable<any>;
  public nextPageQueryParams$: Observable<any>;


  public pageName: any;
  announcements$: Observable<Announcement[]>;
  previewAnnouncements$: Observable<Announcement[]>;
  matchedAnnouncementCount$: Observable<number>;
  filterIsExpanded$: Observable<boolean>;
  providerWebsiteUrlMap$: Observable<{ [index: number]: string }>;

  topBanner$: Observable<Banner>;
  listBanner$: Observable<Banner>;
  leftBanner$: Observable<Banner>;

  isLoading$: Observable<boolean>;

  userType$: Observable<any>;
  
  // sticky `top` of the sidebar (px), null on smaller screens where the sidebar isn't sticky
  sidebarTop: number | null = null;
  private lastScrollY = 0;

  ngOnInit(): void {
    this.providerWebsiteId = this.envService.tenantId;
    
    const deviceInfo = this.deviceDetectionService.detectDevice();
    this.isDesktop = deviceInfo.isDesktop;
    this.targetId = deviceInfo.isDesktop ? BannerTargetEnum.Desktop : BannerTargetEnum.Responsive;

    let searchPageBanners$ = this.store.select(selectSearchPageBannerIds);
    let providerWebsiteId$ = this.store.select(selectCurrentWebsite);

    combineLatest([searchPageBanners$, providerWebsiteId$])
    .pipe(
      filter(([banners, provderWebsite]) =>{
        return banners.bannerIdList.length > 0 && provderWebsite !== null && provderWebsite !== undefined;
      }),
      take(1)
    )
    .subscribe(
      ([b, p]) => {
        this.store.dispatch(sendBannerViewToAnalytic({payload:{bannerIdList: b, providerWebsiteId:p.providerWebsiteId, pageId: BannerHeaderPositionId.FrontPage}}))
      }
    )

    this.store.dispatch(loadLastListingPage({payload: PageNameEnum.SearchResultsPage}));
    if(this.ssr.isPlatformBrowser()){
      this.store.dispatch(getSearchPageBannerList({payload: {targetId: this.targetId, bannerHeadId: BannerPositionEnum.Search_results}}));
    }

    this.salaryOptions$ = this.store.pipe(select(selectSalaryOptions({ emptyItemName: 'All'})));
    this.publishDateOptions$ = this.store.pipe(select(selectPublishDateOptions));
    this.search$ = this.store.pipe(select(selectSearchState));
    this.pageCount$ = this.store.pipe(select(selectPageCount));
    this.navItems$ = this.store.pipe(select(selectDisplayPages));
    this.nextPageQueryParams$ = this.store.pipe(select(selectNextSearchPageQueryParams));
    this.previousePageQueryParams$ = this.store.pipe(select(selectPreviuseSearchPageQueryParams))


    this.previewAnnouncements$ = this.store.pipe(select(selectPreviewAnnouncements));
    this.announcements$ = this.store.pipe(select(selectAnnouncements));
    this.matchedAnnouncementCount$ = this.store.pipe(select(selectMatchedAnnouncementCount));
    this.filterIsExpanded$ = this.store.pipe(select(selectIsExpanded));
    this.providerWebsiteUrlMap$ = this.store.pipe(select(ProviderWebsiteUrlMap));

    this.topBanner$ = this.store.pipe(select(selectSearchPageTopBanner));
    this.listBanner$ = this.store.pipe(select(selectSearchPageListtBanner));
    this.leftBanner$ = this.store.pipe(select(selectSearchPageLeftBanner));

    //this.store.dispatch(loadFrontPageAnnouncements());
    
    this.isLoading$ = this.store.pipe(select(selectIsSearchResultLoading));

    this.userType$ = this.store.select(selectCurrentUserType);
 
    this.metaDataSubscription = this.store.pipe(select(selectSearchResultMetaData)).subscribe(
      (data) => {
        this.metaService.updateMetaData(data.website, data.metaData);
      }
    )
  }

  ngOnDestroy() {
    this.metaDataSubscription.unsubscribe();
  }


  @HostListener('window:scroll')
  onScroll() {
    this.closeAllDropdowns();
    this.updateSidebarTop();
  }

  @HostListener('window:resize')
  onResize() {
    this.updateSidebarTop();
  }

  clickOnSideBar() {
    // opening/closing filter fields changes the sidebar height
    this.updateSidebarTop();
  }

  onResizeWindowWidth(filterIsExpanded: boolean) {
    if (this.isDesktop && window.innerWidth < Breakpoints.huge) {
      this.isDesktop = false;
    } else if (!this.isDesktop && window.innerWidth > Breakpoints.huge) {
      this.isDesktop = true;

      if (filterIsExpanded) {
        this.store.dispatch(toggleExpandFilter());
      }
    }
  }

  // The sidebar is `position: sticky`, so the browser keeps it inside the wrapper (never over the footer).
  // A sidebar that fits the viewport sticks right under the header. A taller one scrolls along with the
  // page until its bottom (scrolling down) or its top (scrolling up) edge is visible, and sticks there.
  private updateSidebarTop() {
    const scrollY = window.scrollY;
    const delta = scrollY - this.lastScrollY;
    this.lastScrollY = scrollY;

    const sideBar = this._document.getElementById('sticky');
    if (!sideBar || window.innerWidth <= Breakpoints.huge) {
      this.sidebarTop = null;
      return;
    }

    const maxTop = this.getHeaderBottom();
    const minTop = Math.min(maxTop, window.innerHeight - sideBar.offsetHeight);
    const top = (this.sidebarTop ?? maxTop) - delta;

    this.sidebarTop = Math.min(maxTop, Math.max(minTop, top));
  }

  private getHeaderBottom(): number {
    const header = this._document.querySelector('header');
    return header ? Math.max(0, header.getBoundingClientRect().bottom) : 0;
  }

  private closeAllDropdowns() {
    this.safeClose(() => this.searchFilter.tree.closeDropdown());
    this.safeClose(() => this.searchFilter.publishDateDropdown.hide());
    this.safeClose(() => this.searchFilter.transportTypeMultiSelect.hide());
    this.safeClose(() => this.searchFilter.workScheduleMultiSelect.hide());
    this.safeClose(() => this.searchFilter.seniorityLevelMultiSelect.hide());
    this.safeClose(() => this.searchFilter.locationTreeSelect.treeSelect.hide());
    this.safeClose(() => this.searchFilter.specializationTreeSelect.treeSelect.hide());
    this.safeClose(() => this.searchFilter.industryTreeSelect.treeSelect.hide());
    this.safeClose(() => this.searchFilter.announcementTypeDropdown.dropdown.hide());
    this.safeClose(() => this.searchFilter.salaryDropdown.dropdown.hide());
  }
  
  private safeClose(action: () => void) {
    try {
      action();
    } catch {
      // Ignore errors when components are not initialized yet.
    }
  }



}
  

// enum AnnouncementFilterQueryParams{
//   AnnouncementType='t',
//   Categories='c',
//   Experience='e',
//   Locality='l',
//   PublishDate='p',
//   Query='q',
//   Salary='s'
// }